import { render, staticRenderFns } from "./BizBusinessinfoInvoiceForm.vue?vue&type=template&id=18f1c7b9&scoped=true&"
import script from "./BizBusinessinfoInvoiceForm.vue?vue&type=script&lang=js&"
export * from "./BizBusinessinfoInvoiceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f1c7b9",
  null
  
)

export default component.exports